<div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-5">
    <div *ngFor="let item of fields.options.staticOptions"
        class="bg-white p-4 border border-dashed border-gray-300 rounded-xl">
        <h3 class="text-center font-semibold text-gray-800 mb-2">{{ item.text }}</h3>
        <div class="flex items-center text-sm text-red-500 justify-center gap-1 mb-4 text-center">
            <i class="ki-filled ki-cross-circle text-danger text-base text-2xl"></i>
            <span class="text-danger break-words text-wrap">{{ item.helpText }}</span>
        </div>

        <div id="chart" class="flex justify-center items-center">
            <ng-container *ngIf="getChartOptions(item) as chartOpts">
                <apx-chart [series]="chartOpts.series" [chart]="chartOpts.chart" [plotOptions]="chartOpts.plotOptions"
                    [labels]="chartOpts.labels" [fill]="chartOpts.fill" [stroke]="chartOpts.stroke">
                </apx-chart>
            </ng-container>
        </div>
    </div>
</div>